export function extractPlanVariantAddon(rawPlanVariantAddon: $TSFixMe) {
  return {
    id: rawPlanVariantAddon.id,
    currency: rawPlanVariantAddon.currency,
    name: rawPlanVariantAddon.name,
    price: rawPlanVariantAddon.price
      ? parseFloat(rawPlanVariantAddon.price)
      : undefined,
    type: rawPlanVariantAddon.type,
    assets: rawPlanVariantAddon.assets,
    storage: rawPlanVariantAddon.storage,
    countryBlacklist: rawPlanVariantAddon.country_blacklist
      ? rawPlanVariantAddon.country_blacklist
      : [],
    disabled: rawPlanVariantAddon.disabled,
  };
}

export function extractPlanVariantAddons(rawPlanVariantAddons: $TSFixMe) {
  return rawPlanVariantAddons.map((planVariantAddon: $TSFixMe) =>
    extractPlanVariantAddon(planVariantAddon),
  );
}
